import * as React  from 'react';
import { useEffect, useRef } from 'react';
import InlineEditableField from '../../InlineEditableField';
import { insertStringScript, removeErrorOnFocus } from "../../../common/util";

const runPreScript = (id, preScript) => {
    insertStringScript(id, preScript);
};

const runPostScript = (id, postScript) => {
    insertStringScript(id, postScript);
};

const Name = (props) => {
    const isMounted = useRef(false);
    const prevDataRef = useRef();

    const renderOnCard = () => {
        return (
            <div></div>
        )
    };

    const renderOnGrid = () => {
        return (
            <div></div>
        )
    };

    const renderOnDetail = () => {
        let {renderType, data, showLabel=false} = props;
        if(Array.isArray(data))
            data = data[0];
        if(renderType.toLowerCase() === 'activity'){
            return (showLabel) ?
                    (<li data-test={data.Label}><label>{data.Label}: </label>{data.Value?data.Value:'-'}</li>)
                :
                    (<li data-test={data.Value}>{data.Value?data.Value:'-'}</li>)
        } else if(renderType.toLowerCase() === 'workkard'){
            return (showLabel) ?
                    (<li data-test={data.Label}>
                        <label data-field-label={props.isShowDetailOnPopUp ? data.FieldKey+"label_block" : data.FieldKey}>{data.Label} </label>
                        {(props.dragndrop || !props.isShowDetailOnPopUp) ?
                            (<span>{data.Value ? data.Value : '-'}</span>)
                            : <InlineEditableField
                                type="number"
                                data={data}
                                canEdit={props.canEditWorkkard}
                                isCompositeField={false}
                                fieldValue={data.Value ? data.Value : '-'}
                                removeErrorOnFocus={(e) => removeErrorOnFocus(e)}
                                updateField={(data) => props.updateWorkkardFieldInfo(data)} />
                        }
                        </li>)
                :
                    (data.Value?data.Value:'-')
        } else{
            return (showLabel) ?
                    (<React.Fragment><label>{data.Label}: </label>{data.Value?data.Value:'-'}</React.Fragment>)
                :
                    (data.Value?data.Value:'-')
        }
    };

    const renderOnCreate = () => {
        return (
            <div>need to insert template</div>
        )
    };

    useEffect(() => {
        const data = Array.isArray(props.data) ? props.data[0] : props.data;
         if (data && data.preInitScript) {
             runPreScript(`preInitScript-${data.FieldKey}`,data.preInitScript);
         }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const newData = Array.isArray(props.data) ? props.data[0] : props.data;
        if (!isMounted.current) {
            isMounted.current = true;
            prevDataRef.current = newData;
            return;
        }
        const oldData = prevDataRef.current;
        prevDataRef.current = newData;
        if(oldData && oldData.Id!=newData.Id && props.renderType.toLowerCase() === 'note'){
            const oldPreInitScripts=document.querySelector(`script[id='preInitScript-${oldData.FieldKey}']`);
            const oldPreSaveScripts=document.querySelector(`script[id='preSaveScript-${oldData.FieldKey}']`);
            const newPreInitScript=newData.preInitScript;
            const newPreSaveScript=newData.PreSaveScript;
            //$('#'+newData.FieldKey).val('');
            if(oldPreInitScripts){
                oldPreInitScripts.parentNode.removeChild(oldPreInitScripts);
            }
            if(oldPreSaveScripts){
                oldPreSaveScripts.parentNode.removeChild(oldPreSaveScripts);
            }
            if (newPreInitScript) {
                runPreScript(`preInitScript-${newData.FieldKey}`,newPreInitScript);
            }
            if (newPreSaveScript) {
                runPostScript(`preSaveScript-${newData.FieldKey}`,newPreSaveScript);
            }
        }
    });

    switch (props.renderLocation.toLowerCase()) {
        case "card":
            return renderOnCard();
        case "grid":
            return renderOnGrid();
        case "detail":
            return renderOnDetail();
        case "create":
            return renderOnCreate();
    }
};

export default Name;
